import type { ReactNode } from 'react';
import { Outlet } from '@tanstack/react-router';
import { Nav } from './Nav';
import { Footer } from './Footer';
import { CatalogSearchProvider } from '../features/catalog/search/CatalogSearchProvider';

export interface SiteLayoutProps {
  /** footer style; detail pages use `slim` */
  footer?: 'full' | 'slim';
  /** the landing page, whose hero frame carries its own nav row */
  landing?: boolean;
  /** explicit content; defaults to the routed `<Outlet />` when omitted */
  children?: ReactNode;
}

/**
 * App shell: Nav + routed content + Footer.
 *
 * The main is full width so a `Band` can simply be a full-width section instead
 * of clawing its way back out of a narrower parent with a negative margin,
 * which was always a scrollbar's width off.
 */
export const SiteLayout = ({ footer = 'full', landing = false, children }: SiteLayoutProps) => (
  <CatalogSearchProvider>
    <div className="flex min-h-screen flex-col">
      <Nav landing={landing} />
      <main className="flex-1">{children ?? <Outlet />}</main>
      <Footer variant={footer} />
    </div>
  </CatalogSearchProvider>
);
